import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaModal from './VaModal.vue'

export const VaModal = withConfigTransport(_VaModal)
